export default __webpack_public_path__ + "static/01-a3c95bff1977747fc5783ec6ce1c2b70.jpg";